/** 官方寄售补贴期：挂牌价高于买家价时返回划线价展示值 */
export function resolveListingStrikePrice(item) {
  if (!item) return null;
  const listing = Number(item.consignListingPrice);
  const buyer = Number(item.price);
  if (!Number.isFinite(listing) || !Number.isFinite(buyer) || listing <= buyer) {
    return null;
  }
  return listing;
}

/** 货主改价/展示使用的售卖价（优先 consignListingPrice） */
export function resolveConsignorDisplayPrice(item) {
  if (!item) return null;
  const listing = item.consignListingPrice != null ? item.consignListingPrice : item.consign_listing_price;
  if (listing != null && listing !== "") return listing;
  const price = item.price;
  return price != null && price !== "" ? price : null;
}

export const DEFAULT_CONSIGN_PROMO_DISCOUNT_RATE = 0.96;

/** 从已有挂牌价/买家价反推折扣，否则用默认 96 折 */
export function resolveConsignPromoDiscountRate(item) {
  if (!item) return DEFAULT_CONSIGN_PROMO_DISCOUNT_RATE;
  const listing = Number(
    item.consignListingPrice != null ? item.consignListingPrice : item.consign_listing_price
  );
  const buyer = Number(item.price);
  if (Number.isFinite(listing) && Number.isFinite(buyer) && listing > 0 && buyer > 0 && listing > buyer) {
    return Math.round((buyer / listing) * 10000) / 10000;
  }
  return DEFAULT_CONSIGN_PROMO_DISCOUNT_RATE;
}

export function isOfficialConsignmentProduct(item) {
  if (!item) return false;
  return Number(item.productType) === 1;
}

/** 官方寄售补贴期：改价按挂牌价录入并自动算买家价 */
export function shouldApplyConsignPromoOnEdit(item) {
  if (!isOfficialConsignmentProduct(item)) return false;
  const listing = item.consignListingPrice != null ? item.consignListingPrice : item.consign_listing_price;
  if (listing != null && listing !== "") return true;
  return resolveListingStrikePrice(item) != null;
}

export function applyBuyerPriceFromListing(listingPrice, discountRate) {
  const listing = Number(listingPrice);
  if (!Number.isFinite(listing) || listing <= 0) return null;
  let rate = Number(discountRate);
  if (!Number.isFinite(rate) || rate <= 0 || rate >= 1) {
    rate = DEFAULT_CONSIGN_PROMO_DISCOUNT_RATE;
  }
  return Math.round(listing * rate * 100) / 100;
}



// WEBPACK FOOTER //
// ./src/util/officialConsignment.js